// extracted by mini-css-extract-plugin
export default {"results":"OWcYwJF1B8_M3bKs8Eeo","resultRow":"_jtcXhbAUcgaEy9w9lOG","selectedRow":"ZMSTAn6TL1UehVVKu_Uu"};